var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Organizer"},[_c('div',{staticClass:"Organizer__filter",style:(_vm.attrStyles)},[_vm._t("filter")],2),(_vm.hasTags())?_c('div',{staticClass:"Organizer__tags",style:(_vm.attrStyles)},[_vm._t("tag")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }